const signInModalOpened = ref(false);
const verifyRequestModalOpened = ref(false);
const settingsModalOpened = ref(false);
const feedbackModalOpened = ref(false);

export const useModals = () => {
  const openSignInModal = () => {
    signInModalOpened.value = true;
  };

  const closeSignInModal = () => {
    signInModalOpened.value = false;
  };

  const toggleSignInModal = (value: boolean) => {
    if (value === undefined) {
      signInModalOpened.value = !signInModalOpened.value;
      return;
    }

    if (value) {
      openSignInModal();
    } else {
      closeSignInModal();
    }
  };

  const openVerifyRequestModal = () => {
    verifyRequestModalOpened.value = true;
  };
  const closeVerifyRequestModal = () => {
    closeSignInModal();
    verifyRequestModalOpened.value = false;
  };

  const toggleVerifyRequestModal = (value: boolean) => {
    if (value === undefined) {
      verifyRequestModalOpened.value = !verifyRequestModalOpened.value;
      return;
    }

    if (value) {
      openVerifyRequestModal();
    } else {
      closeVerifyRequestModal();
    }
  };

  const openSettingsModal = () => {
    settingsModalOpened.value = true;
  };
  const closeSettingsModal = () => {
    settingsModalOpened.value = false;
  };
  const toggleSettingsModal = (value: boolean) => {
    if (value === undefined) {
      settingsModalOpened.value = !settingsModalOpened.value;
      return;
    }
    if (value) {
      openSettingsModal();
    } else {
      closeSettingsModal();
    }
  };

  const openFeedbackModal = () => {
    feedbackModalOpened.value = true;
  };
  const closeFeedbackModal = () => {
    feedbackModalOpened.value = false;
  };
  const toggleFeedbackModal = (value: boolean) => {
    if (value === undefined) {
      feedbackModalOpened.value = !feedbackModalOpened.value;
      return;
    }
    if (value) {
      openFeedbackModal();
    } else {
      closeFeedbackModal();
    }
  };

  return {
    signInModalOpened,
    openSignInModal,
    closeSignInModal,
    toggleSignInModal,

    verifyRequestModalOpened,
    openVerifyRequestModal,
    closeVerifyRequestModal,
    toggleVerifyRequestModal,

    settingsModalOpened,
    openSettingsModal,
    closeSettingsModal,
    toggleSettingsModal,

    feedbackModalOpened,
    openFeedbackModal,
    closeFeedbackModal,
    toggleFeedbackModal,
  };
};

export default useModals;
